module.exports = __webpack_public_path__ + "static/empty_cart-ac0b208cf81b025ffc2512c40e3d339d.png";